const userActionTypes = {
  getUser: 'user/getUser',
  updateUser: 'user/updateUser',
  getPromoCodeExpiration: 'user/getPromoCodeExpiration',
};

export default userActionTypes;
